import { plainToInstance } from 'class-transformer'
import i18n from 'vue-i18n'

import { MenuSectionNames, SocketNames } from '../../../../../components'
import { BaseNodeModelData } from '../../../BaseNode/BaseNodeDataModel'
import { BaseNodeModel } from '../../../BaseNode/BaseNodeModel'
import { CustomNode, CustomNodeComponent, NodeTypes } from '../../../index'
import CheckLimitedSubscriptionsSampleNode from '../ui/SampleNode/CheckLimitedSubscriptionsSampleNode.vue'
import CheckLimitedSubscriptionSidebar from '../ui/Sidebar/CheckLimitedSubscriptionSidebar.vue'
import { CheckLimitedSubscriptionNodeProps } from './types'

export default class CheckLimitedSubscriptionNodeBuilder extends CustomNodeComponent {
  menuSection = MenuSectionNames.Limited
  sidebarComponent = CheckLimitedSubscriptionSidebar

  constructor(i18n: i18n, nodeProps: CheckLimitedSubscriptionNodeProps) {
    super(CheckLimitedSubscriptionsSampleNode, CheckLimitedSubscriptionNode, NodeTypes.CheckLimitedSubscription, i18n, nodeProps)
  }

  getBaseNodeModel = ([ x, y ]: [number, number]) => {
    return {
      data: plainToInstance(CheckLimitedSubscriptionNodeData, {
        type: NodeTypes.CheckLimitedSubscription,
        success_output: CustomNode.LastSocketId += 1,
        fail_output: CustomNode.LastSocketId += 1,
        target: null,
        offset: 0,
      }),
      input: CustomNode.LastSocketId += 1,
      color: null,
      x,
      y,
    }
  }
}

export class CheckLimitedSubscriptionNode extends CustomNode {
  data: CheckLimitedSubscriptionNodeData

  declare nodeProps: CheckLimitedSubscriptionNodeProps

  constructor(name: NodeTypes.CheckLimitedSubscription, model: BaseNodeModel, nodeProps: CheckLimitedSubscriptionNodeProps) {
    super(name, model, nodeProps)

    if (model.data instanceof CheckLimitedSubscriptionNodeData) {
      this.data = model.data

      this.socketActions.createOutput(model.data.success_output, SocketNames.Success)
      this.socketActions.createOutput(model.data.fail_output, SocketNames.Fail)
    } else {
      throw new Error('To node come unknown data')
    }
  }

  setTarget(target: number): void {
    this.data.target = target
  }

  setOffset(offset: number): void {
    this.data.offset = offset
  }
}

export class CheckLimitedSubscriptionNodeData extends BaseNodeModelData {
  declare type: NodeTypes.CheckLimitedSubscription
  success_output!: number
  fail_output!: number
  target!: number | null
  offset!: number
}
